import { BloomUniversalGuestGate } from '@/modules/bloom-universal/components/BloomUniversalGuestGate';
import { BloomUniversalHubScreen } from '@/modules/bloom-universal';

/**
 * Public Bloom Universal hub — lists all Bloom spaces.
 * Flat route `/universal` (avoids trailing-slash clash with a static folder).
 * Hub/space images come from Contentful (not local `public/` assets).
 * Guests only (web).
 */
export default function UniversalRoute() {
  return (
    <BloomUniversalGuestGate>
      <BloomUniversalHubScreen />
    </BloomUniversalGuestGate>
  );
}
